"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGaugeRawSet = void 0;
var fetch_1 = require("../../utils/fetch");
var routes_1 = require("./routes");
function fetchGaugeRawSet(host, metric) {
    return (0, fetch_1.customFetch)({
        body: JSON.stringify(metric),
        headers: [
            ['Content-Type', 'application/json'],
        ],
        host: host,
        method: 'POST',
        path: routes_1.API_ROUTES.GAUGE_RAW_SET,
    });
}
exports.fetchGaugeRawSet = fetchGaugeRawSet;
//# sourceMappingURL=fetchGaugeRawSet.js.map